export default __webpack_public_path__ + "static/media/litho-templates-library-07.810a7aca.jpg";